export class CreateOrUpdateTaskIntegrationParameterDto {
  id: number;
  integrationParameterId: number;
  value: string;
  valueId: number;
}
